import { render } from "./OrderItemDetails.vue?vue&type=template&id=98fcf21a"
import script from "./OrderItemDetails.vue?vue&type=script&lang=js"
export * from "./OrderItemDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__